import {BaseEntity} from "./BaseEntity";
import {IVTag} from "./IVTag";

export class FixedVTag implements BaseEntity, IVTag {
    vTagPositionType:string = "Fixed";
    constructor(public id?:number,
                public name?:string,
                public vTagID?:string,
                public vTagX?:number,
                public vTagY?:number,
                public vTagZ?:number,
                public locationID?:number,
                public vTagLastSeen?:string,
                public batteryLevel?:number,
                public locationName?:string,
                public readerID?:number,
                public readerName?:string,
                public vTagType?:string,
                public lastModifiedBy?:string) {
    }
    isActiveTag(minutes:number){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.vTagLastSeen == null ? Date.now() : Date.parse(this.vTagLastSeen);
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        //console.log("fixed tag "+this.vTagID+" lastSeen="+this.vTagLastSeen+" and diffMinutes="+diffMinutes+" and minutes="+minutes);
        if(diffMinutes > minutes)
            return false;
        else
            return true;
    }
    isGPSTag():boolean{
        if(this.vTagType == "VTag GPS")
            return true;
        else if(this.vTagID != null && this.vTagID.length > 0 && this.vTagID.charAt(0) == 'D')
            return true;
        else
            return false;
    }
    isRecentlyActive(){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.vTagLastSeen == null ? Date.now() : Date.parse(this.vTagLastSeen);
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        if(diffMinutes < 5)
            return true;
        else
            return false;
    }
    search(txt:string):boolean{
        if(txt == null || txt.length == 0)
            return true;
        var search:string = txt.toLowerCase();
        if(this.vTagID != null && this.vTagID.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.locationName != null && this.locationName.toLowerCase().indexOf(search) != -1)
            return true;
        if(this.readerName != null && this.readerName.toLowerCase().indexOf(search) != -1)
            return true;
        return false;
    }

    parseJson(json:any):void{
        this.id = json.id;
        this.name = json.name;
        this.vTagID  = json.vTagID;
        this.vTagX = json.vTagX;
        this.vTagY = json.vTagY,
            this.vTagZ = json.vTagZ,
            this.vTagType = json.vTagType,
            this.batteryLevel = json.batteryLevel != null ? json.batteryLevel.toFixed(2) : null,
            this.locationName = json.locationName,
            this.locationID = json.locationID,
            this.readerName = json.readerName,
            this.vTagLastSeen = json.vTagLastSeen == null ? "" : json.vTagLastSeen;
        this.readerID = json.readerID;
        this.lastModifiedBy = json.lastModifiedBy;
    }
    hasVTagData(){
        if(this.vTagX != null && this.vTagY != null)
            return true;
        else
            return false;
    }
}
